/**
 * VERSIONE LIBRERIA 3
 *
 * Controllo per la gestione degli hasmany con upload
 * gestisce sia gli attachments che le foto.
 * 
 */
var RenderHasmanyUpload = Render.extend({
    type : 'hasmany_upload',
    classData : 'hasmany_upload',
    classTemplate : 'hasmany_upload',
    itemViewTemplate : null,  // template del singolo item di view
    itemEditTemplate : null,  // template del singolo item di edit
    idItemPreviewTemplate : null, // id del template da utilizzare per la preview
    langs : ['it'],
    uploadType : null,
    limit : null,
    modelName : null,
    uploadModelName : null,
    icons : {
        "default"   : 'fa fa-3x fa-file-o',
        "xls"       : 'fa fa-3x fa-file-excel-o',
        "zip"       : 'fa fa-3x fa-file-archive-o',
        "mp3"       : 'fa fa-3x fa-audio-o',
        "jpg"       : "fa fa-3x fa-image-o",
        "pdf"       : "fa fa-3x fa-file-pdf-o"
    },
    //common_fields
    common_fields : {
        foto : ['ext','random','id','status','original_name','filename','mimetype'],
        attachment : ['ext','random','id','status','original_name','filename','mimetype'],
    },
    extra_fields : {
        foto : [],
        attachment : [],
    },
    lang_fields : {
        foto : ['nome','descrizione'],
        attachment : ['nome','descrizione']
    },

    label_field : 'nome_it',
    icon_selector : "[data-icon_img]",

    init: function (key,config) {

        this._super(key,config);

        if (!this.itemViewTemplate)
            this.itemViewTemplate = '#' + this.prefixTemplateClass + '_' + this.uploadType + '_view_item_tpl';
        if (!this.itemEditTemplate)
            this.itemEditTemplate = '#' + this.prefixTemplateClass + '_' + this.classTemplate + '_edit_item_tpl';
        if (!this.idItemPreviewTemplate)
            this.idItemPreviewTemplate = '#' + this.prefixTemplateClass + "_" + this.uploadType + "_item_preview_tpl";

        if (!this.uploadModelName) {
            this.uploadModelName = this.uploadType;
        }
    },

    _renderEdit : function (jQe) {
        var self = this;
        var html = '';
        jQe.find('[data-upload_title]').html($.translate('model-'+self.uploadModelName,2));
        jQe.find('[data-button_add]').html($.translate('general-add') + " " + $.translate('model-'+self.uploadModelName,1))
        jQe.find("[data-render_list]").attr('data-render_list',self.key)
        for (var i in self.value) {
            html += self._createItem(self.value[i], 'updated');
        }


        jQe.find("[data-render_limit]").addClass("hide");
        jQe.find('[data-render_list="' + self.key + '"]').html(html);
        jQe.find("[data-pk]").attr('data-pk',self.key);
        var exists = self.key + "_exists";
        $('<input>').attr({
            type: 'hidden',
            name: exists,
            value : 1
        }).appendTo(jQe);
    },
    _finalizeEdit : function() {
        var self = this;
        self._bindActions();
        self._checkLimit();
        if ( $(self.container).length == 0 ) {
            log.warn("Upload " + self.uploadType + " container not found " , self.container);
            return ;
        }
        $(self.container).find('[data-button_add]').click(function () {
            self.addEditItem();
        });
        $(self.container).find(".sort_class").sortable({
            handle: '.button-move',
        });
    },
    _renderView : function(jQe) {
        var self = this;
        if (self.value.length > 0) {
            var items = self.value;
            if (self.limit) {
                items = [];
                for (var j=0;j<self.limit;j++) {
                    if (j < self.value.length)
                        items.push(self.value[j]);
                }
            }
            $.renderTemplate(self.itemViewTemplate,jQe.find('[data-render_list]'),items);
        } else {
            jQe.find('[data-button_upload]').addClass('disabled');
        }
    },
    _finalizeView : function() {

    },
    /**
     * crea l'item html da aggiungere alla form del modello
     **/
    _createItem : function (values,status) {
        var self = this;
        values.status=status;
        values['random_id'] = values.id?values.id:new Date().getTime();
        values['langs'] = self.langs;
        values['label'] = values[self.label_field]?values[self.label_field]:"";
        values['icon'] = self.icons[values.ext]?self.icons[values.ext]:self.icons["default"];
        var tmpContainer = $.createDynamicContainer(self.itemEditTemplate);
        // setto il template della preview per il tipo di upload
        tmpContainer.find('[data-preview]').attr('data-template',self.idItemPreviewTemplate);

        log.debug("RenderHasmanyUpload._createItem",self.itemEditTemplate,values);
        for (var i in self.common_fields[self.uploadType]) {
            var field = self.common_fields[self.uploadType][i];
            tmpContainer.find('[data-model_fields]').append(
                $('<input>').attr({
                    type: 'hidden',
                    name: self.key + "-" + field + "[]",
                    value : values[field]
                })
            )
        }
        for (var i in self.extra_fields[self.uploadType]) {
            var field = self.extra_fields[self.uploadType][i];
            tmpContainer.find('[data-model_fields]').append(
                $('<input>').attr({
                    type: 'hidden',
                    name: self.key + "-" + field + "[]",
                    value : values[field]
                })
            )
        }
        for (var i in self.lang_fields[self.uploadType]) {
            var field = self.lang_fields[self.uploadType][i];
            for (var k in self.langs) {
                var lang = self.langs[k];
                tmpContainer.find('[data-model_fields]').append(
                    $('<input>').attr({
                        type: 'hidden',
                        name: self.key + "-" + field + "_" + lang +  "[]",
                        value : values[field+"_"+lang]
                    })
                )
            }

        }

        $.renderTemplate('#'+tmpContainer.attr('id'), '#'+tmpContainer.attr('id'), values);

        tmpContainer.find(self.icon_selector).addClass(self.icons[values.ext]).addClass('fa-3x');
        // TODO com'e' il link per il download, sia in temp (new) che in edit
        tmpContainer.find('[data-pk]').attr("data-pk", values.id);
        var html = tmpContainer.html();//obj.html();
        tmpContainer.remove();
        return html;
    },

    /**
     * aggancia gli eventi sui pulsanti degli upload
     */
    _bindActions : function () {
        var self = this;
        $(self.container).find('[data-button_delete]').unbind('click');
        $(self.container).find('[data-button_delete]').click(function () {
            var index = $(this).closest("[data-upload_item]").index();
            self.deleteItem(index);
        });
        $(self.container).find('[data-button_edit]').unbind('click');
        $(self.container).find('[data-button_edit]').click(function () {
            alert('da implementae');
            return ;
            var index = $(this).closest("[data-upload_item]").index();
            self.addEditItem(index);
        });
    },
    /**
     * controlla se e' stato raggiunto il limite degli upload inseribili. In quel caso
     * nasconde il bottone aggiungi
     */
    _checkLimit : function () {
        var self = this;

        if (!self.limit) {
            $(self.container).find("[data-render_limit]").addClass("hide");
            $(self.container).find('[data-button_add]').removeClass("hide");
            return ;
        }
        // conto gli elementi tenendo conto di eventuali delete
        var numItems = 0;
        $.each($(self.container).find('[data-upload_item]'), function () {
            if (!$(this).hasClass('hide'))
                numItems++;
        })
        log.debug("CHECK LIMIT",numItems,self.limit);
        if (numItems >= self.limit) {
            $(self.container).find("[data-render_limit]").removeClass("hide");
            $(self.container).find('[data-button_add]').addClass("hide");
        } else {
            $(self.container).find("[data-render_limit]").addClass("hide");
            $(self.container).find('[data-button_add]').removeClass("hide");
        }

    },
    renderNewItem : function (values) {
        var self = this;
        var html = self._createItem(values, 'new');
        log.debug("upload new item",self.container,'[data-render_list="'+ self.key + '"]');
        $(self.container).find('[data-render_list="'+ self.key + '"]').append(html);
        self._bindActions();
        self._checkLimit();
    },

    deleteItem : function (index) {
        var self = this;
        var hasManyContainer = $(self.container).find('[data-render_list]');
        var status = hasManyContainer.find('input[name="' + self.key + '-status[]"]:eq('+index+')').val();
        log.debug(self.uploadType +  ".deleteItem  status " + status);
        //hasManyContainer.find()

        if (status == "new") {
            hasManyContainer.find('[data-upload_item]:eq('+index+')').remove();
            self._checkLimit();
        } else {
            $.confirmDialog("Rimuovo " + self.uploadType + "?").ok(function () {
                hasManyContainer.find('input[name="' + self.key + '-status[]"]:eq('+index+')').attr("value",'deleted');
                hasManyContainer.find('[data-upload_item]:eq('+index+')').addClass("hide");
                self._checkLimit();
            });
        }
    },
    addEditItem : function (index) {
        var self = this;
        if (""+index != 'undefined') {
            var itemContainer = $(self.container).find('[data-render_list]').get(index);
            var tplData = {};
            $.each($(itemContainer).find('input'),function () {
                tplData[$(this).attr('name')] = $(this).val();
            });
            console.log('ADDETDITITEMMMMM',tplData);
        }




        log.info("action upload " + self.key + " type " + self.uploadType);
        var body = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + 'hasmany_upload_dialog_content_tpl');
        var modelName = self.modelName;

        var params = {
            modelName: Utility.camelCase(modelName),
            random_id : "tdialog" + self.uploadType,
            langs : self.langs,
            type : self.key,
            icon : "",
            filename : 'default.png',
        }
        $(body).find('[data-preview]').attr('data-template',self.idItemPreviewTemplate);
        $.renderTemplate('#'+body.attr('id'), '#'+body.attr('id'), params);

        var dialogId = self._getDialogId();
        console.log('DALOG: ',dialogId);

        $(dialogId + ' .modal-body').html(body.html());
        $(dialogId + ' .modal-title').html($.translate('general-add') + ' ' + $.translate('model-'+self.uploadModelName));
        $(dialogId + ' [data-file-label]').html($.translate('general-accepted-extensions'));
        $(dialogId + ' [data-estensioni-label]').html($.translate('general-extensions-'+self.uploadModelName));

        body.remove();
        $(dialogId + ' .btok').addClass("disabled");

        $(dialogId + ' form').ajaxForm({
            beforeSubmit: function (a, f, o) {
                o.dataType = 'json';
                self._hideError();
                $.waitStart();
            },
            error: function (data, error, msg) {
                //alert("JSON error" + data + ' ' + error + ' ' + msg);
                $.waitEnd();
                //$.errorDialog("Upload error " + data + " " + error + " " + msg);
                self._showError("Upload error " + data + " " + error + " " + msg)
                $(dialogId + ' .btok').addClass("disabled");
            },
            success: function (data) {
                $.waitEnd();
                if (data.error) {
                    //$.errorDialog("Error: " + data.msg.toString());
                    console.log('SELF: ',self.uploadType);
                    self._showError(data.msg);
                    $(dialogId + ' .btok').addClass("disabled");
                    return;
                }
                if (self.uploadType == 'foto') {
                    var image_src = Facade.getUrl('/imagecache/small/' + data.result.filename);
                    //$(dialogId + ' .preview').attr('src',image_src ).removeClass('hide');
                    $(dialogId + " [data-icon]").attr('src',image_src );
                }
                else {
                    //var icon_src = Facade.getUrl("/imagecache/icon/" + self.icons[data.result.ext]);
                    //$(dialogId + ' .preview').attr("src", icon_src).removeClass('hide');
                    $(dialogId + " [data-icon]").addClass(self.icons[data.result.ext]);
                }

                // aggiorno i campi di contorno di uploadfoto
                for (var k in data.result) {
                    $(dialogId + ' form').find('input[name="' + k + '"]').attr('value', data.result[k]);
                }
                // aggiorno il nome con il nome file se non valorizzato
                for (var i in self.langs) {
                    var lang = self.langs[i];
                    if (!$(dialogId + ' form').find('input[name="nome_' + lang + '"]').attr('value')) {
                        $(dialogId + ' form').find('input[name="nome_'+ lang+'"]').attr('value', data.result['original_name']);
                    }
                }
                /*
                 if ($('#upload_foto_dialog form').find('input[name="nome"]').attr('value') == '') {
                 $('#upload_foto_dialog form').find('input[name="nome"]').attr('value', data.result['original_name']);
                 }
                 */
                $(dialogId + ' .btok').removeClass("disabled");
                self.afterUpload(data);
            }
        });
        // auto upload
        $(dialogId + ' input[name="file"]').autoUpload(function () {
            $(dialogId + ' form').submit();
        })

        $(dialogId).modal('show').ok(function () {
            self.ok();
            /*
            var formData = $(dialogId + ' form').serializeAssoc();
            // self.viewObj.addFotoItem(formData,key);
            formData.updated_at  = new Date();
            self.renderNewItem(formData);
            */
        }).cancel(function () {
            //alert('cancel');
            self.cancel();
        })
    },

    _getTemplate : function () {
        var self = this;
        if (self.mode == 'edit')
            return self._super();

        var tplId = self.templateId;
        if (!tplId) {
            tplId = '#'+self.prefixTemplateClass+"_"+self.uploadType+"_"+self.mode+"_tpl";
            if ($(tplId).length == 0)
                tplId = '#'+self.prefixTemplateClass+"_"+self.type+"_tpl";
            if ($(tplId).length == 0)
                throw "Template source " + '#'+self.prefixTemplateClass+"_"+self.uploadType+"_"+self.mode+"_tpl Not found";
        }

        return $.createDynamicContainer(tplId);
    },
    _getDialogId : function () {
        var self = this;
        return '#' + self.prefixTemplateClass + '_' + self.classTemplate + '_dialog';
    },
    _showError : function (msg) {
        var self = this;
        $(self._getDialogId() + ' .alert').removeClass('hide').html(msg)
    },
    _hideError : function () {
        var self = this;
        $(self._getDialogId() + ' .alert').addClass('hide').html('')
    },
    /**
     * azione ok della popup che richiede l'upload dell'oggetto
     */
    ok : function() {
        var self = this;
        var dialogId = self._getDialogId();
        var formData = $(dialogId + ' form').serializeAssoc();
        // self.viewObj.addFotoItem(formData,key);
        formData.updated_at  = new Date();
        self.renderNewItem(formData);
    },
    /**
     * azione cancel della popup
     */
    cancel : function () {

    },

    getValue : function () {
        var self = this;
        var values = [];
        $.each( $(self.container + " ul li"),function() {
            var v = $(this).find('input').serializeArray();
            var itemValues = {};
            for(var k in v) {
                itemValues[v[k].name] = v[k].value;
            }
             values.push(itemValues);
        });
        return values;
    },
    /**
     * metodo chiamato dopo che il file e' stato uploadato
     * @param data: dati in json ritornati dal backend
     */
    afterUpload : function (data) {
    },


});
